<template>
  <div>
    <p class="response-title">文本系列</p>
    <p class="response-h">创建重排序请求</p>
    <p class="response-d">Creates a rerank request.</p>
    <div class="response-i">
      <div class="response-i-box">
        <span class="left">POST</span> <span>/rerank</span>
      </div>
      <!-- <div class="response-btn">Try it</div> -->
    </div>
    <div class="response-next">
      <p class="next-title">Authorizations</p>
      <el-divider class="response-line"></el-divider>
      <div>
        <span class="next-d">Authorization</span
        ><el-tag type="info" size="mini">string</el-tag
        ><el-tag type="info" size="mini">header</el-tag
        ><el-tag type="danger" size="mini">required</el-tag>
      </div>
      <p class="next-a">
        Use the following format for authentication: Bearer
        &lt;your api key&gt;
      </p>
    </div>
    <div class="response-next">
      <p class="next-title">
        Body<span
          style="
            float: right;
            font-size: 0.75rem;
            margin-top: 7px;
            font-weight: 500;
            color: rgb(86 84 90);
          "
          >application/json</span
        >
      </p>
      <el-divider class="response-line"></el-divider>

      <div>
        <span class="next-d">model</span
        ><el-tag type="info" size="mini">{{ model }}</el-tag
        ><el-tag type="danger" size="mini">required</el-tag>
      </div>
      <p class="nex-c">
        Corresponding Model Name. To better enhance service quality, we will
        make periodic changes to the models provided by this service, including
        but not limited to model on/offlining and adjustments to model service
        capabilities. We will notify you of such changes through appropriate
        means such as announcements or message pushes where feasible.
      </p>
      <div style="margin-top: 2vh" class="next-p">
        <span style="margin-right: 5px">Available options:</span>
        <el-tag type="info" size="mini">BAAI/bge-reranker-v2-m3</el-tag>,
        <el-tag type="info" size="mini"
          >netease-youdao/bce-reranker-base_v1</el-tag
        >
      </div>
      <div style="margin-top: 25px">
        <span style="margin-right: 5px">Example:</span>
        <el-tag type="info" size="mini">"BAAI/bge-reranker-v2-m3"</el-tag>
      </div>
      <el-divider></el-divider>

      <div>
        <span class="next-d">query</span>
        <el-tag type="info" size="mini">string</el-tag>
        <el-tag type="info" size="mini">default:Apple</el-tag>
        <el-tag type="danger" size="mini" style="margin-left: 10px"
          >required</el-tag
        >
      </div>
      <p class="nex-c">Required. The search query.</p>
      <span style="margin-right: 5px">Example:</span>
      <el-tag type="info" size="mini">"Apple"</el-tag>

      <el-divider></el-divider>
      <div>
        <span class="next-d">documents</span
        ><el-tag type="info" size="mini">string [ ]</el-tag
        ><el-tag type="danger" size="mini">default:float</el-tag>
      </div>
      <p class="nex-c">
        Currently, only string lists are supported. Document objects will be
        supported in the future.
      </p>
      <div style="margin-top: 25px">
        <span style="margin-right: 5px">Example:</span>
        <div class="code-container">
          <pre><code class="language-javascript" style="border-radius: 10px;;"> ["apple", "banana", "fruit", "vegetable"]</code></pre>
        </div>
      </div>
      <el-divider></el-divider>

      <div>
        <span class="next-d"> top_n</span>
        <el-tag type="info" size="mini">integer</el-tag>
      </div>
      <p class="nex-c">
        Number of most relevant documents or indices to return.
      </p>
      <div style="margin-top: 25px">
        <span style="margin-right: 5px">Example:</span>
        <el-tag type="info" size="mini">4</el-tag>
      </div>
      <el-divider></el-divider>
      <div>
        <span class="next-d"> return_documents</span>
        <el-tag type="info" size="mini"> boolean</el-tag>
        <el-tag type="info" size="mini"> default:false</el-tag>
      </div>
      <p class="nex-c">
        If false, the response does not include document text; if true, it
        includes the input document text.
      </p>
      <!-- <div style="margin-top: 25px">
      <span style="margin-right: 5px">Example:</span>
        <el-tag type="info" size="mini">4</el-tag>
      </div> -->
      <el-divider></el-divider>
      <div>
        <span class="next-d"> max_chunks_per_doc </span>
        <el-tag type="info" size="mini"> integer</el-tag>
        <el-tag type="info" size="mini"> default:1024</el-tag>
      </div>
      <p class="nex-c">
        Maximum number of chunks generated from within a document. Long
        documents are divided into multiple chunks for calculation, and the
        highest score among the chunks is taken as the document's score.
      </p>
      <!-- <div style="margin-top: 25px">
      <span style="margin-right: 5px">Example:</span>
        <el-tag type="info" size="mini">4</el-tag>
      </div> -->
      <el-divider></el-divider>
      <div>
        <span class="next-d"> overlap_tokens </span>
        <el-tag type="info" size="mini"> integer</el-tag>
        <el-tag type="info" size="mini"> default:80</el-tag>
      </div>
      <p class="nex-c">
        Number of token overlaps between adjacent chunks when documents are
        chunked.
      </p>
      <div style="margin-top: 25px">
        <span style="margin-right: 5px">Required range:</span>
        <el-tag type="info" size="mini">x <= 80</el-tag>
      </div>
      <el-divider></el-divider>
      <p class="next-title">
        Response<span class="lineSelect">
          <span style="margin-right: 46px; line-height: 30px; font-size: 12px"
            >application/json</span
          >
        </span>
        <span class="lineSelect lineSelect-num">
          <el-select
            v-model="valueNum"
            size="mini"
            @change="numClick"
            class="lineSelect"
          >
            <el-option label="200" value="200"> </el-option>
            <el-option label="400" value="400"> </el-option>
            <el-option label="401" value="401"> </el-option>
            <el-option label="404" value="404"> </el-option>
            <el-option label="429" value="429"> </el-option>
            <el-option label="503" value="503"> </el-option>
            <el-option label="504" value="504"> </el-option>
          </el-select>
        </span>
      </p>

      <!----->

      <el-divider class="response-line"></el-divider>
      <div v-if="numellJson">
        <div style="margin-bottom: 20px">200</div>
        <div>
          <span class="next-d">id</span
          ><el-tag type="info" size="mini">string</el-tag>
          <el-tag type="danger" size="mini"> required </el-tag>
        </div>

        <el-divider></el-divider>
        <div>
          <span class="next-d"> results </span
          ><el-tag type="info" size="mini">object [ ]</el-tag>
          <el-tag type="danger" size="mini"> required </el-tag>
        </div>
        <el-collapse style="margin-bottom: 24px" @change="moChange">
          <el-collapse-item :title="moTitle" name="1">
            <div>
              results <span class="next-d">.document </span>
              <el-tag type="info" size="mini">object</el-tag>
            </div>
            <p class="nex-c" style="margin-top: 20px">
              Original document content.
            </p>
            <el-collapse style="margin-bottom: 24px" @change="usaChange">
              <el-collapse-item :title="usaTitle" name="1">
                <div>
                  results.document <span class="next-d">.text </span>
                  <el-tag type="info" size="mini">string</el-tag>
                </div>
              </el-collapse-item>
            </el-collapse>

            <div>
              data <span class="next-d">.embedding </span>
              <el-tag type="info" size="mini">number [ ]</el-tag>
              <el-tag type="danger" size="mini"> required </el-tag>
            </div>
            <el-divider></el-divider>
            <div>
              data <span class="next-d">.index </span>
              <el-tag type="info" size="mini">integer</el-tag>
              <el-tag type="info" size="mini">number [ ]</el-tag>
              <el-tag type="danger" size="mini"> required </el-tag>
            </div>
          </el-collapse-item>
        </el-collapse>


        <!----->

        <div>
          <span class="next-d">tokens
            </span
          ><el-tag type="info" size="mini">object</el-tag>
          <el-tag type="danger" size="mini"> required </el-tag>
        </div>
        
        <el-collapse style="margin-bottom: 24px" @change="teChange">
          <el-collapse-item :title="teTitle" name="1">
            <div>
              tokens <span class="next-d">.input_tokens
              </span>
              <el-tag type="info" size="mini">integer</el-tag>
         
            </div>
       
            <el-divider></el-divider>
            <div>
              tokens <span class="next-d">.output_tokens </span>
         
            </div>

           
          </el-collapse-item>
        </el-collapse>

        <!----->


        <div v-if="numsb">
          <div style="margin-bottom: 20px">BadRequest</div>
          <div>
            <span class="next-d">code</span
            ><el-tag type="info" size="mini">integer | null</el-tag>
            <el-tag type="info" size="mini">default:false</el-tag>
            <el-tag type="danger" size="mini">required</el-tag>
          </div>
          <div style="margin-top: 25px">
            <span style="margin-right: 5px">Example:</span>
            <el-tag type="info" size="mini">20012</el-tag>
          </div>
          <el-divider></el-divider>

          <span class="next-d">message</span
          ><el-tag type="info" size="mini">string</el-tag>
          <el-tag type="danger" size="mini">required</el-tag>
          <el-divider></el-divider>

          <span class="next-d">data</span
          ><el-tag type="info" size="mini">string</el-tag>
          <el-tag type="danger" size="mini">required</el-tag>
        </div>
      </div>
      <div v-if="numsb">
        <div style="margin-bottom: 20px">BadRequest</div>
        <div>
          <span class="next-d">code</span
          ><el-tag type="info" size="mini">integer | null</el-tag>
          <el-tag type="info" size="mini">default:false</el-tag>
          <el-tag type="danger" size="mini">required</el-tag>
        </div>
        <div style="margin-top: 25px">
          <span style="margin-right: 5px">Example:</span>
          <el-tag type="info" size="mini">20012</el-tag>
        </div>
        <el-divider></el-divider>

        <span class="next-d">message</span
        ><el-tag type="info" size="mini">string</el-tag>
        <el-tag type="danger" size="mini">required</el-tag>
        <el-divider></el-divider>

<span class="next-d">data</span
><el-tag type="info" size="mini">string</el-tag>
<el-tag type="danger" size="mini">required</el-tag>
</div>
      <div v-if="numsly">
        <div style="margin-bottom: 20px">Unauthorized</div>
        <p class="nex-c">
          The response is of type
          <el-tag type="info" size="mini">string</el-tag>.
        </p>
        <div style="margin-top: 25px">
          <span style="margin-right: 5px">Example:</span>
          <el-tag type="info" size="mini">"Invalid token"</el-tag>
        </div>
      </div>
      <div v-if="numsls">
        <div style="margin-bottom: 20px">NotFound</div>
        <p class="nex-c">The response is of type string.</p>
        <div style="margin-top: 25px">
          <span style="margin-right: 5px">Example:</span>
          <el-tag type="info" size="mini">"404 page not found"</el-tag>
        </div>
      </div>
      <div v-if="numsrj">
        <div style="margin-bottom: 20px">RateLimit</div>
        <div>
          <span class="next-d">message</span
          ><el-tag type="info" size="mini">string</el-tag>
          <el-tag type="danger" size="mini">required</el-tag>
        </div>
        <div style="margin-top: 25px">
          <span style="margin-right: 5px">Example:</span>
          <el-tag srtle="    text-wrap: auto;" type="info" size="mini"
            >"Request was rejected due to rate limiting. If you want more,
            please contact contact@siliconflow.cn."</el-tag
          >
          <el-tag srtle="    margin-left: 71px;" type="info" size="mini">
            Details:TPM limit reached."</el-tag
          >
        </div>
        <el-divider></el-divider>
        <div>
          <span class="next-d">data</span
          ><el-tag type="info" size="mini">string</el-tag>
          <el-tag type="danger" size="mini">required</el-tag>
        </div>
      </div>
      <div v-if="numwls">
        <div style="margin-bottom: 20px">Overloaded</div>
        <div>
          <span class="next-d">code</span
          ><el-tag type="info" size="mini">integer</el-tag>
          <el-tag type="danger" size="mini">required</el-tag>
        </div>
        <div style="margin-top: 25px">
          <span style="margin-right: 5px">Example:</span>
          <el-tag srtle="    text-wrap: auto;" type="info" size="mini"
            >50505</el-tag
          >
        </div>
        <el-divider></el-divider>
        <div>
          <span class="next-d">message</span
          ><el-tag type="info" size="mini">string</el-tag>
          <el-tag type="danger" size="mini">required</el-tag>
        </div>
        <div style="margin-top: 25px">
          <span style="margin-right: 5px">Example:</span>
          <el-tag srtle="    text-wrap: auto;" type="info" size="mini"
            >"Model service overloaded. Please try again later."</el-tag
          >
        </div>

        <el-divider></el-divider>
        <div>
          <span class="next-d">data</span
          ><el-tag type="info" size="mini">string</el-tag>
          <el-tag type="danger" size="mini">required</el-tag>
        </div>
      </div>
      <div v-if="numwlf">
        <div style="margin-bottom: 20px">Timeout</div>

        <div style="margin-top: 25px">
          <span style="margin-right: 5px">The response is of type:</span>
          <el-tag srtle="    text-wrap: auto;" type="info" size="mini"
            >string.</el-tag
          >
        </div>
      </div>
      <div
        style="
          margin-top: 70px;
          font-size: 14px;
          font-weight: bold;
          overflow: hidden;
          color: rgb(71 69 74);
          cursor: pointer;
        "
      >
        <span style="float: left" @click="goPre"> < 创建嵌入请求 </span>
      </div>
      <el-divider></el-divider>
      <div>Powered by Mintlify</div>
    </div>
  </div>
</template>
  <script>
export default {
  data() {
    return {
      valueStr: "string",
      nextActive: "LLM",
      model: "enum<string>",
      stopValue: "string | null",
      aa: "enum<string>",
      menu: "enum<string>",
      valueType: "application/json",
      valueNum: "200",
      numellJson: true,
      numellText: false,
      numsb: false,
      numsly: false,
      numsls: false,
      numsrj: false,
      numwls: false,
      numwlf: false,

      moTitle: "Show child attributes",
      usaTitle: "Show child attributes",
      teTitle: "Show child attributes",

    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    zlClick() {
      // 说明是200
      if (this.valueType == "application/json") {
        this.numellJson = true;
        this.numellText = false;
        this.numsb = false;
        this.numsly = false;
        this.numsls = false;
        this.numsrj = false;
        this.numwls = false;
        this.numwlf = false;
      } else {
        this.numellJson = false;
        this.numellText = true;
        this.numsb = false;
        this.numsly = false;
        this.numsls = false;
        this.numsrj = false;
        this.numwls = false;
        this.numwlf = false;
      }
    },

    numClick() {
      // 说明是200
      if (this.valueNum == "200") {
        if (this.valueType == "application/json") {
          this.numellJson = true;
          this.numellText = false;
          this.numsb = false;
          this.numsly = false;
          this.numsls = false;
          this.numsrj = false;
          this.numwls = false;
          this.numwlf = false;
        } else {
          this.numellJson = false;
          this.numellText = true;
          this.numsb = false;
          this.numsly = false;
          this.numsls = false;
          this.numsrj = false;
          this.numwls = false;
          this.numwlf = false;
        }
      }
      if (this.valueNum == "400") {
        this.numellJson = false;
        this.numellText = false;
        this.numsly = false;
        this.numsb = true;
        this.numsls = false;
        this.numsrj = false;
        this.numwls = false;
        this.numwlf = false;
      }
      if (this.valueNum == "401") {
        this.numellJson = false;
        this.numellText = false;
        this.numsb = false;
        this.numsly = true;
        this.numsls = false;
        this.numsrj = false;
        this.numwls = false;
        this.numwlf = false;
      }
      if (this.valueNum == "404") {
        this.numellJson = false;
        this.numellText = false;
        this.numsly = false;
        this.numsb = false;
        this.numsls = true;
        this.numsrj = false;
        this.numwls = false;
        this.numwlf = false;
      }
      if (this.valueNum == "429") {
        this.numellJson = false;
        this.numellText = false;
        this.numsly = false;
        this.numsb = false;
        this.numsls = false;
        this.numsrj = true;
        this.numwls = false;
        this.numwlf = false;
      }

      if (this.valueNum == "503") {
        this.numellJson = false;
        this.numellText = false;
        this.numsly = false;
        this.numsb = false;
        this.numsls = false;
        this.numsrj = false;
        this.numwls = true;
        this.numwlf = false;
      }
      if (this.valueNum == "504") {
        this.numellJson = false;
        this.numellText = false;
        this.numsly = false;
        this.numsb = false;
        this.numsls = false;
        this.numsrj = false;
        this.numwls = false;
        this.numwlf = true;
      }
    },
    goNext() {
      this.$router.push({
        path: "/api-reference/embedding?type=wbqr",
      });
    },
    goPre() {
      this.$router.push({
        path: "/api-reference/embedding?type=wbqr",
      });
    },

    usaChange(activeNames) {
      console.log(activeNames);
      if (activeNames[0] === "1") {
        //  打开的
        this.usaTitle = "Hide child attributes";
      } else {
        this.usaTitle = "Show child attributes";
      }
    },
    moChange(activeNames) {
      console.log(activeNames);
      if (activeNames[0] === "1") {
        //  打开的
        this.moTitle = "Hide child attributes";
      } else {
        this.moTitle = "Show child attributes";
      }
    },
    teChange(activeNames) {
      console.log(activeNames);
      if (activeNames[0] === "1") {
        //  打开的
        this.teTitle = "Hide child attributes";
      } else {
        this.teTitle = "Show child attributes";
      }
    },
  },
};
</script>
  <style scoped>
.response-title {
  color: rgb(124 57 238);
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.response-h {
  font-size: 1.875rem;
  line-height: 2.25rem;
  color: #000;
  font-weight: 700;
  margin: 1.1vh 0;
}
.response-d {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.response-i {
  border: 1px solid rgb(228 227 231 / 70%);
  padding: 0.375rem;
  border-radius: 15px;
  width: 97%;
  font-weight: bold;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  /* margin-bottom:12vh */
  /* height: 36px; */
}
.response-i .left {
  color: rgb(29 78 217);
  padding: 3px 9px;
  background: rgba(96, 165, 250, 0.2);
  border-radius: 6px;
  height: 16px;
  line-height: 18px;
  font-size: 0.9rem;
  float: left;
  margin-top: 2px;
  margin-right: 10px;
  font-weight: bold;
}
.response-i-box {
  border: 1px solid rgb(228 227 231 / 70%);
  padding: 0.375rem;
  border-radius: 12px;
  /* width:100%; */
  height: 25px;
  line-height: 30px;
  line-height: 25px;
  flex: 1;
}
.response-btn {
  background-color: rgb(48 100 229);
  height: 25px;
  margin-left: 15px;
  color: #fff;
  font-weight: bold;
  padding: 0.375rem;
  border-radius: 12px;
  width: 65px;
  line-height: 25px;
  padding-left: 1rem;
  cursor: pointer;
}
.next-title {
  color: #000;
  font-weight: 600;
  margin-top: 2em;
  margin-bottom: 0.5em;
  line-height: 1.5;
  font-size: 1.125em;
}
.next-d {
  margin-right: 10px;
  color: rgb(124 57 238);
  font-weight: 600;
}
.next-a {
  margin-top: 20px;
  font-size: 0.875rem;
  line-height: 1.7142857;
  color: #000;
}
.next-a a {
  color: #000;
  text-decoration: none;
  font-weight: 600;
  border-bottom: 1px solid rgb(158 111 251);
}
.nex-c {
  margin-top: 2vh;
  line-height: 25px;
  font-size: 0.875rem;
  /* font-weight: 500; */
}
.next-p {
  font-size: 0.875rem;
}

.response-next {
  margin-top: 5vh /* height: 36px; */;
}

.response-next /deep/.el-tag.el-tag--info {
  color: rgb(86 84 90);
  font-weight: 600;
  margin-right: 10px;
  background: rgb(240 237 244 / 50%);
  color: #363738;
}
.response-next /deep/.el-tag.el-tag--danger {
  color: rgb(221 39 39);
  font-weight: 600;
}
.next-p /deep/.el-tag.el-tag--info {
  margin-right: 0;
  background-color: rgb(244 242 248 / 50%);

  /* color: #363738; */
}
.response-next /deep/.el-tabs__nav-scroll,
.response-next /deep/.el-tabs__content {
  width: auto;
  min-width: auto;
  padding: 0;
}
.response-next /deep/.el-tab-pane {
  padding: 0;
}
.response-next /deep/.el-collapse {
  border-top: none;
  margin-top: 24px;
}
.lineSelect {
  float: right;
  font-size: 0.75rem;
  font-weight: 500;
  color: rgb(86 84 90);
}
.lineSelect /deep/.el-input__inner {
  border-color: rgb(255 255 255);
  width: 148px;
}
.lineSelect-num {
  margin-right: 70px;
}
.lineSelect-num /deep/.el-input__inner {
  width: 70px;
}
.hideLine /deep/.el-collapse-item__wrap,
.hideLine /deep/.el-collapse-item__header {
  border-bottom: none;
}
</style>
  <style>
.response-line.el-divider--horizontal {
  margin-top: 0.625rem;
  border-color: rgb(242 240 247);
}
.el-collapse-item__header {
  background-color: #fbfafa;
  border-radius: 5px;
  padding-left: 10px;
  margin-bottom: 24px;
}
.el-collapse-item__wrap {
  padding: 0 20px;
}
</style>